import { createSlice } from "@reduxjs/toolkit";
import { LINK_LIST_COLORS } from "../../constants/inputValues";
import { FetchLinkListData } from "../requests/linkList";

const initialState = {
  status: null,
  data: {
    colors: LINK_LIST_COLORS,
    qrTitle: "",
    title: "",
    description: "",
    logo: "",
    links: [],
    socials: [],
    isLogoRound: true,
  },
};

const linksBuilder = createSlice({
  name: "linksBuilder",
  initialState,
  reducers: {
    updateBuilder(state, { payload }) {
      state.data = payload;
    },
    updateBuilderLinks(state, { payload }) {
      state.data.links = payload;
    },
    updateBuilderSocialLinks(state, { payload }) {
      state.data.socials = payload;
    },
    resetBuilder() {
      return initialState;
    },
    setBuilderColors(state, { payload }) {
      state.data.colors = payload;
    },
  },
  extraReducers: {
    [FetchLinkListData.pending]: (state) => {
      state.status = "load";
    },
    [FetchLinkListData.rejected]: (state) => {
      state.status = "failed";
    },
    [FetchLinkListData.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.data.title = payload.title || "";
      state.data.description = payload.description || "";
      if (
        payload.backgroundColor &&
        payload.linkBackgroundColor &&
        payload.linkTextColor
      ) {
        state.data.colors = [
          payload.backgroundColor,
          payload.linkBackgroundColor,
          payload.linkTextColor,
        ];
      } else state.data.colors = LINK_LIST_COLORS;

      state.data.links = payload.links || [];
      if (payload.entrySocialsListLinks) {
        payload.entrySocialsListLinks.forEach((item) => {
          state.data.socials.push({
            id: item.socialsId,
            link: item.socialsLink,
          });
        });
      } else {
        state.data.socials = [];
      }
      state.data.logo = payload.logo || "";
      state.data.qrTitle = payload.qrTitle;
      state.data.isLogoRound = payload.isLogoRound;
    },
  },
});
export const {
  updateBuilder,
  updateBuilderLinks,
  updateBuilderSocialLinks,
  resetBuilder,
  setBuilderColors,
} = linksBuilder.actions;
export default linksBuilder.reducer;
